<template>
  <div :class="[isCollapse == true ? 'addnavbar' : 'delnavbar']">
    <!-- <div class="toggle-button" @click="toggleCollapse">|||</div> -->
    <el-menu
      :router="true"
      default-active="$route.path"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#fff"
      :unique-opened="true"
      :collapse="isCollapse"
      :collapse-transition="false"
    >
       <!-- <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span style="color:white">系统管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/User/" style="padding-left:51px;"> <i class="el-icon-s-custom"></i>用户管理</el-menu-item>
        </el-menu-item-group>      
      </el-submenu>  -->
      <el-submenu :index="item.Url + ''" v-for="item in menuList" :key="item.id">
        <template slot="title">
          <i :class="item.Icon + ''"></i>
          <span style="color:white">  {{$i18n.locale=='en'&&item.EnName!=null?item.EnName:$i18n.locale=='cn'?item.Name:item.Name}}</span>
          <!-- <span style="color:white" v-if="$i18n.locale=='cn'">{{ item.Name}}</span> -->
        </template>
        <el-menu-item :v-if="item.Children!=null" :index="subItem.Url + ''" v-for="subItem in item.Children" :key="subItem.id">
        <template  slot="title">
        <i :class="subItem.Icon + ''"></i>
        <!-- <span  style="color:white" v-if="$i18n.locale=='en'">{{subItem.EnName}}</span>
        <span  style="color:white" v-if="$i18n.locale=='cn'">{{subItem.Name}}</span> -->
         <span style="color:white">  {{$i18n.locale=='en'&&subItem.EnName!=null?subItem.EnName:$i18n.locale=='cn'?subItem.Name:subItem.Name}}</span>
        </template>
      </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<style>
.el-menu-item-group__title {
    padding: 0px 0 0px 0px;
}
.toggle-button {
  background: #545c64;
  color:#fff;
  font-size: 15px;
  line-height:24px;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
 /* 左侧样式 */
  .addnavbar {
    position: absolute;
    width: 60px; 
    top: 50px;  /* 距离上面50像素 */
    left: 0px;
    bottom: 0px;
    overflow-y: auto; /* 当内容过多时y轴出现滚动条 */
    background-color: #545c64;
    
  }
   .delnavbar {
    position: absolute;
    width: 266px;
    top: 50px;  /* 距离上面50像素 */
    left: 0px;
    bottom: 0px;
    overflow-y: auto; /* 当内容过多时y轴出现滚动条 */
    background-color: #545c64;
    /* background-color: white; */
  }
</style>
<script>
export default {
   data() {
      return {
         isCollapse: false, // 菜单是否折叠
         menuList:[]
      }
   },
   created() {
    // 生命周期函数
    this.getUserMenu();
  },
   methods: {
      // 点击切换左侧菜单的折叠与展开
      toggleCollapse() {
         this.isCollapse = !this.isCollapse
      },
      async getUserMenu() {
      this.$http
        .get(this.baseurl.baseURL+"/Api/User/GetCurrentUserMenu")
        .then((res) => {
          if (res.data.Code == 200) {
          this.menuList = res.data.Data; 
          } else if (res.data.Code == 401) {
            this.$router.push("/Login");
          }
        })
        .catch((error) => {
          console.log(error);
        });
      }
   }
}
</script>


// WEBPACK FOOTER //
// src/components/AppNavbar/index.vue